<template>
  <div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div class="permission-alert-msg" v-show="!(ifTeamleaderPermission)">
      You have only view permission.
    </div>
    <div class="payroll-computation" :disabled="!(ifTeamleaderPermission)">
      <div class="row">
        <div class="col-6">
          <div class="payroll-label deductions-text">Pay Days in a Month *</div>
          <div v-for="(paydayType,index) in payDaysmonthList" :key="index">
            <tl-radio
              class="margintop-16"
              :name="'payDaysList'+index"
              :label="paydayType.name"
              :id="paydayType.name"
              :value="paydayType.id"
              @change="currentPayType(paydayType)"
              v-model="payDays"
              data-vv-as="pay days list"
              v-validate="{required: true}"
              :classname="errors.has('payDaysList')"
              :errormsg="errors.first('payDaysList')"
            />
          </div>
          <div v-if="isBaseDays">
            <txt
              class="margintop-16"
              label="Enter Basedays"
              name="BaseDays"
              type="text"
              v-model="payDaysValue.baseDays"
              v-numeric-only
              v-validate="'required|numeric|min_value:1|max_value:31'"
              :classname="errors.has('BaseDays')"
              :errormsg="errors.first('BaseDays')"
            />
          </div>
          <br />
          <!-- <div v-if="isExcludeWeeklyOff">
            <tl-checkbox
              label="Exclude Weekly Off"
              @change="(val)=>{exclude=val}"
              v-model="exclude"
            ></tl-checkbox>
            <div class="marginleft-15" v-if="this.exclude">
              <div class="margintop-24 marginleft-15">
                <ul class="flex-box">
                  <span class="excludelabel">Select Weekly Offs:</span>
                  <li
                    :class="{'selected': day.selected}"
                    v-for="(day,index) in weekDays"
                    :key="index"
                    :value="day.day"
                    @click="weekOffDays(index)"
                  >{{day.day}}</li>
                </ul>
              </div>
            </div>
          </div> -->
          <div class="margintop-32">
            <div class="lable-text deductions-text">Display format of Deduction Arrears</div>
            <div class="row margintop-16 marginleft-15">
              <tl-radio
                name="negativeDeductions"
                class="col-2"
                label="Positive"
                id="deductions1"
                :value="true"
                v-model="formData.deduction"
              />
              <tl-radio
                name="negativeDeductions"
                class="col-1"
                label="Negative"
                id="deductions2"
                :value="false"
                v-model="formData.deduction"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6 margintop-32">
          <div class="lable-text deductions-text">LOP/RLOP Settings</div>
          <div class="row margintop-16 marginleft-15">
            <tl-radio
            name="lopType"
            class="col-2"
            label="Days"
            id="lopType1"
            value="Day"
            v-model="formData.lop_rlop_type"
            />
            <tl-radio
            name="lopType"
            class="col-1"
            label="Dates"
            id="lopType2"
            value="Date"
            v-model="formData.lop_rlop_type"
            />
          </div>
        </div>
      </div>
      <div class="lable-text deductions-text main_div">LOP Applicable</div>
          <div class="row margintop-18 marginleft-18">
            <tl-radio
            name="yesNo"
            class="col-1"
            label="Yes"
            id="yesNo1"
            :value="true"
            v-model="formData.applylop"
        />
          <tl-radio
              name="yesNo"
              class="col-1"
              label="No"
              id="yesNo2"
              :value="false"
              v-model="formData.applylop"
          />
          </div>
    </div>

    <tick-animation v-if="showSuccessMsg"></tick-animation>

    <bottom-action-container class="bottomClass">
      <btn-skip @navClicked="skip"></btn-skip>
      <template slot="end">
        <btn-grp>
          <btn text="Previous" type="secondary" @click="previous" />
          <btn text="Next" type="primary" @click="save" v-show="(ifTeamleaderPermission || ifSuperAdmin || ifAnchor)"/>
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import * as constants from "@/apis/constants.js";

export default {
  name: "PayrollComputation",
  computed: {
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID",
      payCycleId: "onboard/settings/payroll_cycle/payCycleId"
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else {
        return this.getLegalEntityId(0);
      }
    },
    orgId() {
      return this.$store.getters["onboard/getOrgId"];
    },
    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },
    ...mapState("onboard/organization", {
      orgIds: state => state.id,
    }),
    ifTeamleaderPermission() {
      if(this.role === 'TEAMLEADER' || this.role === 'ADMIN') {
        // if(this.legalEntityInfoValue) {
        return true;
        } else {
          return false;
        }
      // }
      // else {
      //  return true
      // }
    },
    ifSuperAdmin() {
      return localStorage.getItem("userRole") == "SUPERADMIN" ? true : false;
    },
  },
  mounted() {
    this.setConstantsData();
    this.setDeafultData();
    this.fetchData();
    this.getOrgLeIdList();
  },
  activated() {
    this.setConstantsData();
    this.setDeafultData();
    this.fetchData();
    this.getOrgLeIdList();
  },
  data() {
    return {
      formData: {
        deduction: "",
        lop_rlop_type: "Day",
        applylop:'false'
      },
      payDaysmonthList: [],
      weekDays: [
        {
          day: "Mon",
          selected: false
        },
        {
          day: "Tue",
          selected: false
        },
        {
          day: "Wed",
          selected: false
        },
        {
          day: "Thu",
          selected: false
        },
        {
          day: "Fri",
          selected: false
        },
        {
          day: "Sat",
          selected: false
        },
        {
          day: "Sun",
          selected: false
        }
      ],
      toast: false,
      selected: false,
      errmsg: "",
      isBaseDays: false,
      isExcludeWeeklyOff: false,
      baseDays: "",
      payDays: "",
      payDaysValue: {},
      exclude: false,
      selectedWeekOffDays: [],
      showSuccessMsg: false,
      payrollPreferencesValue: false,
      role: ""
    };
  },
  methods: {
    ...mapActions({
      act_fetchData: "onboard/settings/payroll_computation/fetchAll",
      act_create: "onboard/settings/payroll_computation/create"
    }),

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),
    /** To set the value of dropdowns from the constants file */
    setConstantsData() {
      try {
        this.payDaysmonthList =
          constants.PayrollComputationConstants.payDaysmonthList;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** On weekly off days change */
    weekOffDays(idx) {
      try {
        this.weekDays[idx].selected = !this.weekDays[idx].selected;
        if (this.weekDays[idx].selected) {
          if (
            !this.selectedWeekOffDays.includes(
              item => item == this.weekDays[idx].day
            )
          ) {
            this.selectedWeekOffDays.push(this.weekDays[idx].day);
          }
        } else {
          // this.selectedWeekOffDays.splice(
          //   this.selectedWeekOffDays.findIndex(
          //     item => item == this.weekDays[idx].day
          //   ),
          //   1
          // );
        }
        this.payDaysValue.weeklyOff = [...new Set(this.selectedWeekOffDays)];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Navigation handling by emits */
    skip() {
      this.$emit("stepNum", 2);
    },
    /** Navigation handling by emits */
    previous() {
      this.$emit("stepNum", 0);
    },
    /** Set default data to the form */
    setDeafultData() {
      try {
        this.payDays = "Fixed";
        this.isBaseDays = true;
        this.isExcludeWeeklyOff = false;
        this.toast = false;
        this.errmsg = "";
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to fetch data from server and to set the form data */
    async fetchData() {
      try {
        let res = await this.act_fetchData(this.leId);
        let payComputationData = res.data.payload.data;
        if (payComputationData) {
          let payrollObject = payComputationData;
          this.payDays = payrollObject.payDaysInMonthId;
          this.selectedWeekOffDays = payrollObject.pay_days_value.weeklyOff
            ? payrollObject.pay_days_value.weeklyOff
            : [];
          this.isExcludeWeeklyOff = this.selectedWeekOffDays
            ? this.selectedWeekOffDays.length
              ? true
              : false
            : false;
          this.exclude = this.isExcludeWeeklyOff ? true : false;
          if (this.selectedWeekOffDays) {
            for (let week of this.weekDays) {
              for (let item of this.selectedWeekOffDays) {
                if (item == week.day) {
                  week.selected = true;
                }
              }
            }
          }
          this.payDaysValue.weeklyOff = this.selectedWeekOffDays;
          for (let index = 0; index < this.payDaysmonthList.length; index++) {
            if (
              this.payDaysmonthList[index].id === payrollObject.pay_day_type
            ) {
              this.currentPayType(this.payDaysmonthList[index]);
              break;
            }
          }
          this.payDaysValue.baseDays = payrollObject.pay_days_value.baseDays
            ? payrollObject.pay_days_value.baseDays
            : "";
          this.formData.deduction = payrollObject.deduction_negative_arrear;
          this.formData.lop_rlop_type = payrollObject.lop_rlop_type ? payrollObject.lop_rlop_type : 'Day';
          this.formData.applylop = payrollObject.applylop ? payrollObject.applylop : 'Yes';
        } else {
          this.payDays = "Fixed";
          this.isBaseDays = true;
          this.isExcludeWeeklyOff = false;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    navHandler(navType) {
      try {
        if (navType == "back") {
          this.$emit("stepNum", 0);
          this.$validator.reset();
        } else if (navType == "next") {
          this.$emit("stepNum", 2);
          this.$validator.reset();
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Submit the form data to server */
    async performAction() {
      try {
        if (this.payDaysValue) {
          //Logic to restrict only to max 6 week offs
          if (this.payDaysValue.weeklyOff) {
            if (this.payDaysValue.weeklyOff.length >= 7) {
              this.toast = true;
              this.errmsg = "Maximum 6 weekly offs are allowed.";
              return;
            }
          }
        } else {
          this.toast = false;
          this.errmsg = "";
        }

        this.weekOffDays(6);
        // if (!(this.payDays == "Fixed")) {
        //   this.payDaysValue.baseDays = null;
        //   if (!this.exclude) {
        //     this.payDaysValue.weeklyOff = [];
        //   } else {
        //     //Logic to apply atleast one week off
        //     if (!this.payDaysValue.weeklyOff.length) {
        //       this.toast = true;
        //       this.errmsg = "Minimum 1 weekly off is needed.";
        //       return;
        //     } else {
        //       this.toast = false;
        //       this.errmsg = "";
        //     }
        //   }
        // } else {
        //   this.payDaysValue.weeklyOff = [];
        // }

        if (this.payDays == "Fixed") {
          this.payDaysValue.weeklyOff = [];
        } else {
          this.payDaysValue.baseDays = "0"
        }
        this.apirequestObj = {
          le_id: this.leId,
          pay_day_type: this.payDays,
          deduction_negative_arrear:
            this.formData.deduction == "true" || this.formData.deduction == true
              ? true
              : false,
          pay_days_value: this.payDaysValue,
          lop_rlop_type: this.formData.lop_rlop_type,
          applylop: this.formData.applylop =="true" || this.formData.applylop == true ? true : false,
          default: true,
          selected_paygroup_id: null
        };

        try {
          this.$root._data.isSaving = true;
          let res = await this.act_create({
            data: {
              ...this.apirequestObj
            }
          });
          setTimeout(() => {
            this.$root._data.isSaving = false;
            if (res.status) {
              this.showSuccessMsg = true;
              this.hideSuccessMsg();
            }
          }, 500);
        } catch (err) {
          this.$root._data.isSaving = false;
          this.toast = true;
          this.errmsg = err;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /* function to hide success message and navigate to next screen */
    hideSuccessMsg() {
      setTimeout(() => {
        this.showSuccessMsg = false;
        this.$emit("stepNum", 2);
      }, 1000);
    },
    /** To validate the form */
    validateForm() {
      this.$validator.validateAll().then(result => {});
    },
    /** Validate the form data */
    save() {
      try {
        if(this.ifAnchor || this.ifSuperAdmin) {
          this.nextPage();
        } else {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.performAction();
          } else {
            this.$el
              .querySelector(
                '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
              )
              .focus();
            this.$el
              .querySelector(
                '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
              )
              .scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "center"
              });
          }
        });
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** On 'Pay Days in a Month' radio buttons change */
    currentPayType(event) {
      try {
        switch (event.name) {
          case "Current month calendar days":
            this.payDays = event.id;
            this.isBaseDays = false;
            this.isExcludeWeeklyOff = true;
            break;
          case "Previous month calendar days":
            this.payDays = event.id;
            this.isBaseDays = false;
            this.isExcludeWeeklyOff = true;
            break;
          case "Fixed base days":
            this.payDays = event.id;
            this.isBaseDays = true;
            this.isExcludeWeeklyOff = false;
            break;
          case "baseDays":
            this.payDays = event.id;
            this.payDaysValue.weeklyOff = [];
            this.isBaseDays = true;
            this.isExcludeWeeklyOff = false;
            break;
          default:
            break;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function is use to move next page as user role is anchor */
    nextPage() {
      this.$emit("stepNum", 2);
    },

    async getOrgLeIdList() {
      const org = this.orgIds;
      const le = this.leId;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.payrollPreferencesValue = data.data.user.permissions.payroll_preferences ? true : false;
      //console.log("PL-3406",data);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
.payroll-computation {
  margin-bottom: 150px;
  width: 100%;
}

.bottomClass {
  margin-top: -80px;
}

.errorr {
  border: 1px solid #e01717;
}

.errorMessage {
  color: #e01717; // padding-top: 1px
}

ul {
  padding-left: 0px;
  margin-left: 24px;
}

.flex-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 4px;
  background: #f9f9f9;
  li {
    list-style: none;
    font-weight: 500;
    padding: 15px 10px;
    cursor: pointer;
    &:hover {
      background-color: #34c0be52;
    }
    &.selected {
      background-color: #34c0be;
    }
  }
}

.payroll-computation .payroll-label {
  font-family: Montserrat;
  font-size: 14px;
  color: #1f1f1f;
  margin-bottom: 4px;
  margin-top: 22px;
  font-weight: 500;
  margin-bottom: 8px;
}
.main_div{
margin-top: 35px; 
margin-left: 15px;
}

.payroll-computation hr {
  height: 2px;
  color: #34c0be;
  background-color: #34c0be;
  border: none;
  opacity: 0.3;
}

.checkbox {
  display: flex;
  position: relative;
  margin-bottom: 17px;
}

[type="radio"]:checked,
[type="radio"]:not(:checked) {
  position: absolute;
  left: -9999px;
}

.checkbox {
  display: flex;
  position: relative;
  margin-bottom: 17px;
}
.marginleft-15 {
  margin-left: -15px;
}
[type="radio"]:checked + label,
[type="radio"]:not(:checked) + label {
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  color: #1f1f1f;
  margin-right: 10px;
}

[type="radio"]:checked + label:before,
[type="radio"]:not(:checked) + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  height: 18px;
  border: 1px solid #5d409f;
  border-radius: 100%;
  background: #fff;
}

[type="radio"]:checked + label:after,
[type="radio"]:not(:checked) + label:after {
  content: "";
  width: 12px;
  height: 12px;
  background: #5d409f;
  position: absolute;
  top: 3px;
  left: 3px;
  border-radius: 100%;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

[type="radio"]:not(:checked) + label:after {
  opacity: 0;
  -webkit-transform: scale(0);
  transform: scale(0);
}

[type="radio"]:checked + label:after {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
}

.excludelabel {
  align-self: center;
  padding-left: 10px;
}

.deductions-text {
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #646464;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}

</style>
